import {useUpmPlantContext} from '@hconnect/upm'
import {
  FeatureFlagConfig,
  FeatureFlagKey,
  checkFeatureFlag,
  useFeatureFlagsQuery
} from '@hproduce/feature-flags'
import React from 'react'
import {Outlet, Navigate} from 'react-router'

import {PlannerPageSkeleton} from '../shared/components/skeletons/PlannerPageSkeleton'

import {getUrl} from './helpers'
import {ROUTES} from './router'

interface FeatureGuardedRouteProps {
  configurationName: FeatureFlagConfig
  featureKey: FeatureFlagKey
}

export const FeatureGuardedRoute: React.FC<FeatureGuardedRouteProps> = ({
  configurationName,
  featureKey
}) => {
  const {plantId} = useUpmPlantContext()
  const {data: featureFlags} = useFeatureFlagsQuery({configurationName, params: {plantId}})

  if (featureFlags === undefined) {
    return <PlannerPageSkeleton />
  }

  if (!checkFeatureFlag(featureFlags, featureKey)) {
    return <Navigate to={getUrl(ROUTES.BASE.NOT_FOUND.path, {})} replace />
  }

  return <Outlet />
}
